import { tv } from 'tailwind-variants';

export const styles = tv({
  base: `
    mt-4
    w-full
    text-center
    after:mx-auto
    after:mt-6
    after:block
    after:h-1
    after:w-28
    after:bg-green-700
    after:content-['']
  `,
});
